module.exports = {
	nav: {
		home: '首页',						// 首页
		about: '关于我们',					// 关于我们
		project: '项目实景',					// 项目实景
		contact: '联系我们',				// 联系我们
		language: '语言',			// 语言选择
	},
	content: {
		// 2021/11/12 内容区 要首字母大写
		about: '关于我们',					// 关于我们
		contact: '联系我们',				// 联系我们
	},
	contact: {
		xing: '姓',		// 姓
		name: '名',		// 名
		email: '邮箱',		// 邮箱
		address: '地址',	// 住址
		zhushi: '意见',		// 意见
		submit: '提交',		// 提交
		bitian: '必填项',	// 必填项
		
		inputXing: '请输入您的姓氏',			// 请输入您的姓氏
		inputName: '请输入您的名字',			// 请输入您的名字
		inputZqEmail: '请输入有效的邮箱号',	// 请输入有效的邮箱号
		
	}
}